export const noSpecialCharactersRegex = /^[A-Za-z0-9 ]*$/;
